import { TextField } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const EmailInput = () => {
  const { t } = useTranslation();

  const [isError, setIsError] = useState(false);

  const isValidEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
  const validateEmail = (e) =>
    isValidEmail.test(e.target.value) || e.target.value === ""
      ? setIsError(false)
      : setIsError(true);

  return (
    <TextField
      fullWidth
      type="email"
      variant="filled"
      label={t("orderIntake.emailCc")}
      onChange={validateEmail}
      error={isError}
    />
  );
};

export default EmailInput;
